module.exports = __webpack_public_path__ + "static/media/venture-beat-logo.aa4c860b.svg";